// extracted by mini-css-extract-plugin
export default {"root":"AnimatedBell__root--1V7RB","informer":"AnimatedBell__informer--31e86","dot":"AnimatedBell__dot--3RcIY","pulse":"AnimatedBell__pulse--3qYMf"};